export const doctors = {
  state: {
    doctorId: null,
    doctorList: []
  },
  mutations: {
    setDoctorId(state, val) {
      state.doctorId = val
    },
    setDoctorList(state, val) {
      state.doctorList = val
    }
  },
  getters: {
    doctorId(state) {
      return state.doctorId
    },
    doctorList(state) {
      return state.doctorList
    },
    doctorName(state) {
      const selectedDoctor = state.doctorList.find(it => it.id === state.doctorId)
      if (selectedDoctor === undefined) {
        return ''
      }
      return selectedDoctor.name
    },
    doctorNote(state) {
      const selectedDoctor = state.doctorList.find(it => it.id === state.doctorId)
      if (selectedDoctor === undefined) {
        return ''
      }
      return selectedDoctor.note
    }
  }
}